import { ref } from 'vue';

// Глобальное состояние модального окна (не Vuex, а просто модуль)
const isOpen = ref(false);

export function useLanguageModal() {
  const openModal = () => {
    isOpen.value = true;
  };
  
  const closeModal = () => {
    isOpen.value = false;
  };
  
  return {
    isOpen, // Убираем readonly, чтобы BaseModal мог изменять значение
    openModal,
    closeModal,
  };
}
